module.exports = __webpack_public_path__ + "static/media/channels.75cea004.JPG";